// Arumi: "Completa tu rutina" recommended products in the cart drawer and cart page
if (!customElements.get('arumi-cart-recs')) {
  class ArumiCartRecs extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.load();
    }

    get limit() {
      return Number(this.dataset.limit) || 6;
    }

    money(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    }

    async load() {
      const inCart = new Set((this.dataset.productIds || '').split(',').filter(Boolean).map(Number));
      const picked = new Map();
      const add = (p) => {
        if (picked.size >= this.limit || inCart.has(p.id) || picked.has(p.id) || !p.variant_id) return;
        picked.set(p.id, p);
      };

      // Shopify's related products for each product in the cart (most recent first)
      const ids = [...inCart].reverse().slice(0, 3);
      for (const id of ids) {
        if (picked.size >= this.limit) break;
        try {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const res = await fetch(`${root}recommendations/products.json?product_id=${id}&limit=10&intent=related`);
          const data = await res.json();
          (data.products || []).forEach((p) => {
            const variant = (p.variants || []).find((v) => v.available);
            if (!p.available || !variant) return;
            add({
              id: p.id,
              title: (p.title || '').split(' | ')[0],
              vendor: p.vendor,
              url: p.url,
              image: p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=240' : '',
              price: variant.price,
              compare_at_price: variant.compare_at_price || 0,
              variant_id: variant.id,
            });
          });
        } catch (e) {}
      }

      // Fill with the store's recommended products
      try {
        JSON.parse(this.querySelector('script[data-fallback]').textContent).forEach(add);
      } catch (e) {}

      if (!picked.size) return;
      this.render([...picked.values()]);
      this.hidden = false;
    }

    render(products) {
      const list = this.querySelector('.arumi-cart-recs__list');
      list.textContent = '';
      products.forEach((p) => {
        const li = document.createElement('li');
        li.className = 'arumi-cart-recs__item';
        const discount = p.compare_at_price > p.price ? Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price) : 0;
        li.innerHTML = `
          <a class="arumi-cart-recs__media" href="${p.url}">
            ${p.image ? `<img src="${p.image}" alt="" width="120" height="120" loading="lazy">` : ''}
            ${discount ? `<span class="arumi-cart-recs__badge">-${discount}%</span>` : ''}
          </a>
          <div class="arumi-cart-recs__info">
            <span class="arumi-cart-recs__vendor"></span>
            <a class="arumi-cart-recs__name" href="${p.url}"></a>
            <span class="arumi-cart-recs__price">${this.money(p.price)}</span>
          </div>
          <button type="button" class="arumi-cart-recs__add" aria-label="">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
            <span>Agregar</span>
          </button>`;
        li.querySelector('.arumi-cart-recs__vendor').textContent = p.vendor || '';
        li.querySelector('.arumi-cart-recs__name').textContent = p.title;
        const button = li.querySelector('.arumi-cart-recs__add');
        button.setAttribute('aria-label', `Agregar ${p.title} al carrito`);
        button.addEventListener('click', () => this.addToCart(p, button));
        list.appendChild(li);
      });
    }

    async addToCart(product, button) {
      button.disabled = true;
      button.classList.add('is-loading');
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: product.variant_id, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error();
        if (this.closest('cart-drawer')) {
          // Re-render the drawer (it rebuilds this list without the added product)
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          const cart = await (await fetch(`${root}cart.js`)).json();
          document.querySelectorAll('cart-count').forEach((el) => { el.textContent = cart.item_count; el.hidden = false; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        } else {
          window.location.reload();
        }
      } catch (e) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.querySelector('span').textContent = 'Reintentar';
      }
    }
  }
  customElements.define('arumi-cart-recs', ArumiCartRecs);
}
